export default __webpack_public_path__ + "static/media/program button.7487d212.png";